import { Icon, IconProps } from '@iconify/react';

export const NavIcon = (props: IconProps) => (
  <Icon height={16} width={16} {...props} />
);
